/** 登入結果狀態 */
export enum LoginResultCode {
  success,
  fail,
  cancel,
}
